import {
  emiratesIdNumberSchema,
  passportNumberSchema,
} from "@features/port-security/schema/portSecurityFormSchema";
import type { TFunction } from "i18next";
import { z } from "zod";

export type CheckSecurityClearanceFormValues = {
  passportNumber?: string;
  emiratesIdNumber?: string;
};

export const getCheckSecurityClearanceSchema = (t: TFunction) =>
  z.object({
    passportNumber: passportNumberSchema(10, t("security-clearance.passport-number")),
    emiratesIdNumber: emiratesIdNumberSchema(t("security-clearance.emirates-id-no")),
  });
